import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

const FORM_STYLE = { minWidth: "15%", maxWidth: "15%" };

export const EventsItemSelector = ({ companyList, onEntityChange }) => {
  const [optionList, setOptionList] = useState({
    companies: [],
    advertisers: [],
    projects: [],
  });
  const [selectedValue, setSelectedValue] = useState({
    company: "none",
    advertiser: "none",
    project: "none",
  });

  useEffect(() => {
    setOptionList((old) => ({
      ...old,
      companies: companyList.map((c) => ({ id: c.company_id, name: c.name })),
    }));
  }, [companyList]);

  const handleCompanyChange = (e) => {
    const selectedCompany = e.target.value;
    setSelectedValue(() => ({
      company: selectedCompany,
      advertiser: "none",
      project: "none",
    }));

    setOptionList((old) =>
      selectedCompany !== "none"
        ? {
            ...old,
            advertisers: companyList
              .find((c) => c.company_id === selectedCompany)
              .advertisers.map((a) => ({ id: a.advertiser_id, name: a.name })),
          }
        : {
            ...old,
            advertisers: [],
            projects: [],
          }
    );
  };
  
  const handleAdvertiserChange = (e) => {
    const selectedAdvertiser = e.target.value;
    setSelectedValue((old) => ({
      ...old,
      advertiser: selectedAdvertiser,
      project: "none",
    }));

    setOptionList((old) =>
      selectedAdvertiser !== "none"
        ? {
            ...old,
            projects: companyList
              .find((c) => c.company_id === selectedValue.company)
              .advertisers.find((a) => a.advertiser_id === selectedAdvertiser)
              .projects.map((p) => ({ id: p.project_id, name: p.name })),
          }
        : {
            ...old,
            projects: [],
          }
    );
  };

  const handleProjectChange = (e) => {
    const selectedProject = e.target.value;
    setSelectedValue((old) => ({
      ...old,
      project: selectedProject,
    }));

      onEntityChange(selectedProject);
  };


  return (
    <Box
      style={{ display: "flex", gap: "1rem", alignItems: "center" }}
      component="div"
    >
      <FormControl sx={FORM_STYLE} size="small">
        <InputLabel id="company-label">Company</InputLabel>
        <Select
          labelId="company-label"
          id="company-select"
          value={selectedValue.company}
          onChange={handleCompanyChange}
          label="Company"
        >
          <MenuItem value="none">
            <em>-</em>
          </MenuItem>
          {optionList.companies.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {optionList.advertisers.length > 0 ? (
        <FormControl sx={FORM_STYLE} size="small">
          <InputLabel id="advertiser-label">Advertiser</InputLabel>
          <Select
            labelId="advertiser-label"
            id="advertiser-select"
            value={selectedValue.advertiser}
            onChange={handleAdvertiserChange}
            label="Advertiser"
          >
            <MenuItem value="none">
              <em>-</em>
            </MenuItem>
            {optionList.advertisers.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <></>
      )}

      {optionList.projects.length > 0 ? (
        <FormControl sx={FORM_STYLE} size="small">
          <InputLabel id="project-label">Project</InputLabel>
          <Select
            labelId="project-label"
            id="project-select"
            value={selectedValue.project}
            onChange={handleProjectChange}
            label="Project"
          >
            <MenuItem value="none">
              <em>-</em>
            </MenuItem>
            {optionList.projects.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <></>
      )}
    </Box>
  );
};
